import Vue from "vue";
import "@/services/helpers";
import Buefy from "buefy";
import Sentry from "@/plugins/sentry";
import Http from "@/plugins/http";
import Helpers from "@/plugins/helpers";

Vue.use(Buefy);
Vue.use(Sentry);
Vue.use(Http);
Vue.use(Helpers);

/*
 |--------------------------------------------------------------------------
 | Main Vue instance
 |--------------------------------------------------------------------------
*/

new Vue({
  el: "#app"
});
